module.exports = __webpack_public_path__ + "img/empreendimento-logo-24-white.5e70115f.png";